import { OptionSelect } from '@/core/utils/types'
import { useMemo } from 'react'
import { DEPARTAMENTO_QUERY } from '../data/departamento'
import { DepartamentoQueryQuery } from '@/core/types/graphql'
import { useQuery } from '@apollo/client'

export const useDepartamentos = () => {
  const { data: { departamentos = [] } = {}, loading } =
    useQuery<DepartamentoQueryQuery>(DEPARTAMENTO_QUERY)

  const departamentosOptions = useMemo(
    () =>
      departamentos?.map(it => ({
        label: it?.nome,
        value: it?.id
      })) as OptionSelect[],
    [departamentos]
  )

  return {
    DepartamentosOptions: departamentosOptions,
    loadingDepartamentos: loading
  }
}
